export const CITIES = [
  {
    id: 1,
    code: "041",
    name: "آذربایجان شرقی",
  },
  {
    id: 2,
    code: "044",
    name: "آذربایجان غربی",
  },
  {
    id: 3,
    code: "084",
    name: "ايلام",
  },
  {
    id: 4,
    code: "045",
    name: "اردبیل",
  },
  {
    id: 5,
    code: "031",
    name: "اصفهان",
  },
  {
    id: 6,
    code: "077",
    name: "بوشهر",
  },
  {
    id: 7,
    code: "021",
    name: "تهران",
  },
  {
    id: 8,
    code: "038",
    name: "چهارمحال و بختیاری",
  },
  {
    id: 9,
    code: "051",
    name: "خراسان رضوی",
  },
  {
    id: 10,
    code: "056",
    name: "خراسان جنوبی",
  },
  {
    id: 11,
    code: "058",
    name: "خراسان شمالی",
  },
  {
    id: 12,
    code: "061",
    name: "خوزستان",
  },
  {
    id: 13,
    code: "024",
    name: "زنجان",
  },
  {
    id: 14,
    code: "023",
    name: "سمنان",
  },
  {
    id: 15,
    code: "054",
    name: "سیستان و بلوچستان",
  },
  {
    id: 16,
    code: "071",
    name: "فارس",
  },
  {
    id: 17,
    code: "026",
    name: "کرج",
  },
  {
    id: 18,
    code: "025",
    name: "قم",
  },
  {
    id: 19,
    code: "028",
    name: "قزوین",
  },
  {
    id: 20,
    code: "087",
    name: "کردستان",
  },
  {
    id: 21,
    code: "034",
    name: "کرمان",
  },
  {
    id: 22,
    code: "083",
    name: "کرمانشاه",
  },
  {
    id: 23,
    code: "074",
    name: "کهگیلویه و بویراحمد",
  },
  {
    id: 24,
    code: "017",
    name: "گلستان",
  },
  {
    id: 25,
    code: "013",
    name: "گیلان",
  },
  {
    id: 26,
    code: "066",
    name: "لرستان",
  },
  {
    id: 27,
    code: "011",
    name: "مازندران",
  },
  {
    id: 28,
    code: "086",
    name: "مرکزی",
  },
  {
    id: 29,
    code: "076",
    name: "هرمزگان",
  },
  {
    id: 30,
    code: "081",
    name: "همدان",
  },
  {
    id: 31,
    code: "035",
    name: "یزد",
  },
];
